import {
  Box,
  Button,
  Container,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { String } from "../../constants/Strings";
import { colors } from "../../style/color/colors";

import { Info } from "@mui/icons-material";

import GridBackground from "../../assets/img/dashboradgrid.svg";
import DashboardPieChart from "./DashboardPieChart";
import TotalAmountCard from "./TotalAmountCard";
import EstimatorCard from "./EstimatorCard";
import SavingGoalCards from "./SavingGoalCards";
import SessionFeedbackForm from "./SessionFeedbackForm";
import { AuthContext } from "../../Hooks/context/AuthContext";
import { useDashboardService } from "../../api/apiEndpoints/Dashboard";
import { AppToast } from "../../commanComponents/AppToast";
import { useNavigate } from "react-router-dom";
import NoGoalsComponents from "./NoGoalsComponents";
import { useEditGoalInDashboard } from "../../api/apiEndpoints/EditGoalsInDashboard";
import { formatToIndianCurrency } from "../../logic/CurrencyFormatter";
import { fonts } from "../../style/fonts/fonts";
import { gaCustomEvent } from "../../logic/CommonFunctions";
import { OTPVerifyContext } from "../../Hooks/context/OTPVeriryContext";

const Dashboard = () => {
  const [isClick, setIsClick] = useState(false);
  const [protectioGoalSelected, setProtectioGoalSelected] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isEditButtonClicked, setIsEditButtonClicked] = useState();
  const [snackbarMessage, setSnackbarMessage] = useState({
    message: "",
    severity: "",
  });
  const [dashboardData, setDashboardData] = useState({
    totalAssets: "",
    assets: [],
    totalNetWorth: "",
    totalLiabilities: "",
    monthlySaving: "",
    monthlyEmis: "",
    insuranceEstimator: {
      currentLifeCoverage: "",
      idealTermLifeInsurance: "",
      percentage: "",
    },
    goals: [],
  });

  const { authTokens } = useContext(AuthContext);
  const { verifyData } = useContext(OTPVerifyContext);
  const { fetchDashboardDetails, saveDashboardDetails } = useDashboardService();
  const { EditGoals } = useEditGoalInDashboard();
  const navigation = useNavigate();

  const { userId } = authTokens;
  const alreadyCompleted = localStorage.getItem(`${userId}_feedback`);

  useEffect(() => {
    const fetchDashboardDetail = async () => {
      if (!userId) {
        return;
      }

      try {
        const response = await fetchDashboardDetails({
          userId: userId,
        });
        setIsEditButtonClicked(response.response.areGoalsEdited);
        setProtectioGoalSelected(
          response.response.goals.length === 0 ? true : false,
        );

        if (response.httpCode === 200) {
          setDashboardData(response.response);
          setSnackbarMessage({
            message: String.Dashboard.mainDashboard.dashboardDataFetchSuccess,
            severity: String.successSeverity,
          });
          setSnackbarOpen(true);
        } else {
          setSnackbarMessage({
            message: String.Dashboard.mainDashboard.dashboardDataFetchError,
            severity: String.ErrorSeverity,
          });
          setSnackbarOpen(true);
        }
      } catch (error) {
        setSnackbarMessage({
          message: String.Dashboard.mainDashboard.dashboardDataFetchError,
          severity: String.ErrorSeverity,
        });
        setSnackbarOpen(true);
      }
    };
    fetchDashboardDetail();
    window.scrollTo(0, 0);
  }, []);

  const showSnackbar = (message, severity) => {
    setSnackbarMessage({ message, severity });
    setSnackbarOpen(true);
  };

  const shareWithPartner = async () => {
    gaCustomEvent(
      String.gaEventName.acrDashboard,
      String.gaEventClickName.acrDashboardFinish,
      verifyData.customerId,
    );

    if (dashboardData.totalAssets === "") {
      showSnackbar(
        String.Dashboard.mainDashboard.completeYourJourneyFirstMessage,
        String.ErrorSeverity,
      );
      return;
    }

    const response = await saveDashboardDetails({ userId: userId });
    const data = {
      userId: userId,
      areGoalsEdited: true,
    };
    await EditGoals(data);

    const fetchResponse = await fetchDashboardDetails({
      userId: userId,
    });

    setIsEditButtonClicked(fetchResponse.response.areGoalsEdited);

    if (response.httpCode === 200 && alreadyCompleted !== "true") {
      showSnackbar(
        String.Dashboard.mainDashboard.dashboardDatasharewithpartnerMessage,
        String.successSeverity,
      );
      setIsClick(true);
    } else {
      showSnackbar(
        String.Dashboard.erroeMessageforNotFetchData,
        String.ErrorSeverity,
      );
    }
  };

  return (
    <Stack
      sx={{
        backgroundColor: colors.SecondaryMidnightBlue,
        height: "100vh",
        overflowY: "aoto",
      }}
    >
      <Container>
        <Box
          sx={{
            display: "flex",
            mt: "40px",
            ml: "8px",
          }}
        >
          <IconButton onClick={() => navigation(-1)}>
            {" "}
            <ArrowBackIcon
              fontSize="medium"
              sx={{
                color: colors.PrimaryWhite,
              }}
            />
          </IconButton>

          <Typography
            sx={{
              color: colors.PrimaryWhite,
              fontSize: "24px",
              fontFamily: fonts.manrope,
              fontWeight: 700,
              mt: "5px",
            }}
          >
            {String.Dashboard.mainDashboard.heading}
          </Typography>
        </Box>
      </Container>
      <Box
        sx={{
          backgroundImage: `url(${GridBackground})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "repeat",
          position: "relative",
          zIndex: 0,
        }}
      >
        <Box sx={{ ml: "30px" }}>
          <Box sx={{ display: "flex", justifyContent: "flex-start", pt: 2 }}>
            <Typography sx={{ fontSize: 12, color: colors.PrimaryWhite }}>
              {String.Dashboard.mainDashboard.TotalAssets}
            </Typography>
            <Tooltip
              title={String.Dashboard.totalAssetToolTip}
              sx={{ position: "relative", ml: "5px" }}
              enterTouchDelay={0}
            >
              <IconButton>
                <Info
                  sx={{
                    width: 12,
                    height: 12,
                    fontSize: "1rem",
                    color: colors.PrimaryWhite,
                    fontFamily: fonts.manrope,
                    fontWeight: "700",
                    left: 0,
                    top: 4,
                    position: "absolute",
                  }}
                />
              </IconButton>
            </Tooltip>
          </Box>
          <Typography
            sx={{
              color: colors.PrimaryWhite,
              fontSize: 25,
              fontFamily: fonts.manrope,
              fontWeight: "700",
              mt: "5px",
            }}
          >
            {formatToIndianCurrency(dashboardData.totalAssets)}
          </Typography>
        </Box>

        <Box
          sx={{
            maxWidth: "100%",
            margin: "0 auto",
            color: colors.PrimaryWhite,
            p: 1,
            borderRadius: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
            "@media (max-width: 600px)": {
              p: 1,
              borderRadius: 2,
            },
          }}
        >
          <DashboardPieChart assets={dashboardData.assets || []} />
        </Box>
      </Box>
      {isClick ? (
        <SessionFeedbackForm setIsClick={setIsClick} />
      ) : (
        <>
          <Box
            sx={{
              backgroundColor: colors.TardisBlue,
              color: colors.PrimaryWhite,
              p: 2,
              borderRadius: 4,
              display: "flex",
              flexDirection: "column",

              mb: 2,
            }}
          >
            <TotalAmountCard
              totalnetWorth={dashboardData.totalNetWorth}
              totalLibalities={dashboardData.totalLiabilities}
              monthlySaving={dashboardData.monthlySaving}
              monthlyEMIs={dashboardData.monthlyEmis}
            />
          </Box>
          <Typography
            sx={{
              color: colors.PrimaryWhite,
              fontSize: 13,
              fontFamily: fonts.manrope,
              fontWeight: "500",
              mb: "30px",
              ml: "30px",
            }}
          >
            {String.Dashboard.mainDashboard.Alldataareindicative}
          </Typography>

          <Container
            sx={{
              background: colors.PrimaryWhite,
              borderTopLeftRadius: 40,
              borderTopRightRadius: 40,
              overflowY: "aoto",
            }}
          >
            {" "}
            <EstimatorCard
              lifeCoverage={
                dashboardData.insuranceEstimator.currentLifeCoverage
              }
              termLifeInsurance={
                dashboardData.insuranceEstimator.idealTermLifeInsurance
              }
              percentage={dashboardData.insuranceEstimator.percentage}
            />
            {protectioGoalSelected === true ? (
              <NoGoalsComponents isEditClick={isEditButtonClicked} />
            ) : (
              <SavingGoalCards
                goals={dashboardData.goals}
                editVal={isEditButtonClicked}
              />
            )}
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "25%",
              }}
            >
              <Button
                style={{
                  width: "80%",
                  height: "50px",
                  maxWidth: "350px",
                  backgroundColor: colors.ColorButtonPrimarysurface,
                  color: colors.PrimaryWhite,
                  borderRadius: "40px",
                  p: "20px",
                  mt: "40px",
                  mb: "30px",
                  lineHeight: "22.2px",
                  fontWeight: 700,
                  fontSize: "16px",
                  textAlign: "center",
                  textTransform: "capitalize",
                }}
                onClick={shareWithPartner}
              >
                {" "}
                {String.Dashboard.mainDashboard.buttonName}{" "}
              </Button>
            </Box>
          </Container>
          <Box
            sx={{
              width: "100%",
              opacity: 0.8,
              background: colors.BroadDaylight,
              mt: "30px",
              mb: "30px",
              textAlign: "center",
            }}
          >
            <Typography
              sx={{
                color: colors.SecondarySummerSky,
                fontSize: 13,
                fontFamily: fonts.manrope,
                fontWeight: "500",
                p: 2,
              }}
            >
              {" "}
              {String.Dashboard.mainDashboard.bottamContent}
            </Typography>
          </Box>
        </>
      )}
      <AppToast
        open={snackbarOpen}
        handleClose={() => setSnackbarOpen(false)}
        message={snackbarMessage.message}
        severity={snackbarMessage.severity}
      />
    </Stack>
  );
};

export default Dashboard;
